import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { translations, LANGUAGES } from './translations';

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('vj_lang') || 'en');

  useEffect(() => {
    const meta = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
    document.documentElement.setAttribute('lang', lang);
    document.documentElement.setAttribute('dir', meta.dir);
    localStorage.setItem('vj_lang', lang);
  }, [lang]);

  const t = useCallback(
    (key) => {
      const dict = translations[lang] || translations.en;
      return dict[key] || translations.en[key] || key;
    },
    [lang]
  );

  const isRtl = (LANGUAGES.find((l) => l.code === lang) || {}).dir === 'rtl';

  return (
    <I18nContext.Provider value={{ lang, setLang, t, isRtl, languages: LANGUAGES }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
};
